function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.7,
  cx: 82,
  cy: 82,
  r: 52,
  fill: "#E35E4C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.9435 66.5814C67.727 65.8028 68.9933 65.8067 69.7719 66.5902L82.4096 79.3073L94.8681 66.7705C95.6467 65.987 96.913 65.9831 97.6965 66.7617C98.48 67.5403 98.484 68.8066 97.7054 69.5901L85.2292 82.1447L98.0586 95.0547C98.8372 95.8382 98.8333 97.1045 98.0498 97.8831C97.2663 98.6617 96 98.6577 95.2214 97.8742L82.4096 84.982L69.4186 98.0546C68.64 98.838 67.3737 98.842 66.5902 98.0634C65.8067 97.2848 65.8028 96.0185 66.5814 95.235L79.59 82.1447L66.9346 69.4098C66.156 68.6263 66.16 67.36 66.9435 66.5814Z",
  fill: "white"
});

function SvgUploadError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadError);
export default __webpack_public_path__ + "static/media/upload_error.02415e62.svg";
export { ForwardRef as ReactComponent };